// @core/api/endpoints/project/list_projects.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListProjectsResponse,
} from '../../../types/project';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/project';

/**
 * List projects
 * Returns a paginated list of projects the caller has access to, with optional filtering by status, parent entity and search term.
 */
export async function ListProjects(
  params?: PaginatedRequest & {
    member_id?: string | number | boolean;
    owner_id?: string | number | boolean;
    parent_id?: string | number | boolean;
    parent_type?: string | number | boolean;
    search?: string | number | boolean;
    status?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListProjectsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/projects`;
  const requestOptions = options;
  return client.get<ListProjectsResponse>(requestPath, { ...requestOptions, params });
}
